import { Container, Modal } from 'react-bootstrap';
import { Dispatch, FC, SetStateAction, useState } from 'react';
import { generalHelpers, urlEncodingLineBreak, urlEncodingPercentage } from '@monorepo/helpers';
import { hideLoadingModalReducer, setAlertResponse, setValuesAndOpenAlertModalReducer, showLoadingModalReducer } from 'src/store';
import { HorizontalSelector, Hr } from 'src/components/_commons';
import { notificationServices } from 'src/services';
import { typeNotification, typeUser } from '@monorepo/models';
import { useDispatch } from 'react-redux';
import { useGetIsDarkMode, useGetIsMobile } from 'src/custom-hooks';

type propsType = {
    notifications: typeNotification[];
    setRefreshCounter: Dispatch<SetStateAction<number>>;
    users: typeUser[];
};

export const NotificationsTodayButton: FC<propsType> = ({ notifications, setRefreshCounter, users }) => {
    const [showModal, setShowModal] = useState(false);
    const isMobile = useGetIsMobile();

    return (
        <>
        {showModal &&
            <NotificationsTodayModal
                closeModal={() => setShowModal(false)}
                notifications={notifications}
                setRefreshCounter={setRefreshCounter}
                users={users}
            />
        }
        <div style={{ position: 'fixed', width: '100%', zIndex: 4 }}>
            <div
                style={{
                    right: isMobile ? '20px' : '0',
                    marginTop: '110px',
                    position: 'fixed',
                    top: 0,
                    transform: isMobile ? '' : 'translateX(-50%)',
                    zIndex: 3
                }}
            >
                <button className={`btn btn-general-blue d-block ${isMobile ? 'btn-sm' : ''}`}
                    style={{ width: '140px' }}
                    onClick={() => setShowModal(true)}
                >
                    Notificaciones
                </button>
            </div>
        </div>
        </>
    );
}

const NotificationsTodayModal: FC<propsType & { closeModal: () => void; }> = ({
    closeModal, notifications, setRefreshCounter, users
}) => {
    const [selectedDate, setSelectedDate] = useState(new Date());
    const dispatch = useDispatch();
    const isDarkMode = useGetIsDarkMode();

    const notificationsCurrentDate = notifications
        .filter(n => n.date === generalHelpers.GetDateStringFromDate(selectedDate))
    ;

    const setNotificationsOfTheDayAgain = async () => {
        dispatch(showLoadingModalReducer());
        const response = await notificationServices.SetNotificationsOfTheDayAgain();
        dispatch(hideLoadingModalReducer());
        if (!response.success) {
            dispatch(setAlertResponse({ response }));
            return;
        }
        setRefreshCounter(x => x + 1);
    }

    return (
        <Modal show fullscreen onHide={closeModal}>
            <Modal.Header className={isDarkMode ? 'bg-dark text-white' : ''} closeButton>
                <Modal.Title>
                    NOTIFICACIONES POR DÍA
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className={isDarkMode ? 'bg-lightdark text-white' : ''}>
                <Container>
                    <div className={'mt-2 mb-4'}>
                        <HorizontalSelector
                            label={generalHelpers.FormatDate(selectedDate)}
                            setNext={() => {
                                const today = new Date();
                                today.setHours(0, 0, 0, 0);
                                const nextDate = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate() + 1);
                                if (nextDate > today) {
                                    return;
                                }
                                setSelectedDate(x => new Date(x.getFullYear(), x.getMonth(), x.getDate() + 1));
                            }}
                            setPrevious={() => {
                                setSelectedDate(x => new Date(x.getFullYear(), x.getMonth(), x.getDate() - 1));
                            }}
                        />
                    </div>
                    {generalHelpers.GetDateStringFromDate(selectedDate) === generalHelpers.GetCurrentLocalDate() &&
                        <div className={'text-center'}>
                            <button className={'btn btn-general-red'}
                                onClick={setNotificationsOfTheDayAgain}
                            >
                                Regenerar
                            </button>
                        </div>
                    }
                    {!!notificationsCurrentDate.filter(n => n.date === generalHelpers.GetDateStringFromDate(selectedDate)).length ?
                        <>
                        <Hr />
                        {notificationsCurrentDate.filter(n => n.date === generalHelpers.GetDateStringFromDate(selectedDate)).map((n, i) =>
                            <div key={i}>
                                <h5>
                                    {users.find(u => u.id === n.userId)?.name} {users.find(u => u.id === n.userId)?.lastName} a las {n.hour.toString().padStart(2, '0')} hs.
                                </h5>
                                <div>
                                    {n.content.replaceAll(urlEncodingPercentage, '%').split(urlEncodingLineBreak).map((x, i) =>
                                        <p key={i}>
                                            {x}
                                        </p>
                                    )}
                                </div>
                                <Hr />
                            </div>
                        )}
                        </>
                        :
                        <>No hay ninguna para esta fecha</>
                    }
                </Container>
            </Modal.Body>
        </Modal>
    );
}
